<template>
  <IconLucideCircleChevronRight />
</template>
